import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { config } from '@config';

const ENVIRONMENT = import.meta.env.VITE_ENV || 'development';

export const initSentry = () => {
  // Don't initialize Sentry if DSN is missing
  if (!config.sentry.dsn) {
    return;
  }

  Sentry.init({
    dsn: config.sentry.dsn,
    debug: ENVIRONMENT === 'local',
    environment: ENVIRONMENT,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // Use config for all Sentry settings
    enabled: config.sentry.enabled,
    tracesSampleRate: config.sentry.tracesSampleRate,
    replaysSessionSampleRate: config.sentry.replaysSessionSampleRate,
    replaysOnErrorSampleRate: config.sentry.replaysOnErrorSampleRate,

    // Enable source maps
    normalizeDepth: 10,

    // Ignore some common errors
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Network request failed',
      /^Script error\.?$/,
      /^Javascript error: Script error\.? on line 0$/,
    ],

    // Don't send personally identifiable information
    sendDefaultPii: false,

    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === 'xhr') {
        // Don't capture request/response bodies
        delete breadcrumb.data?.request;
        delete breadcrumb.data?.response;
      }
      return breadcrumb;
    },
  });

  if (!config.sentry.enabled) {
    console.warn('Sentry initialized but event sending is disabled');
  }
};
